<template>
  <transition name="fade">
    <div class="loading" :class="{'short': short}">
      <div class="loadingBg">
        <div class="loading_tip center">
          <div class="tip1" :class="wordAniPlay?'tip1_ani':''">
            <img src="../../public/imgs/loading_text_1.png" />
          </div>
          <div class="tip2" :class="wordAniPlay?'tip2_ani':''">
            <img src="../../public/imgs/loading_text_2.png" />
          </div>
        </div>

        <div class="paper_container">
          <img
            :class="{show: activeIndex == i}"
            :src="require(`../../public/imgs/papper/loading_papper_${i}.png`)"
            v-for="i in 10"
            :key="i"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import AsyncPreloader from "async-preloader";

let interval;

export default {
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    short: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      percent: 0,
      wxReady: false,
      aniCompleted: false,
      loadingCompleted: false,
      activeIndex: 1,
      wordAniPlay: false
    };
  },

  mounted() {
    let ua = navigator.userAgent.toLowerCase();

    let _this = this;
    if (/micromessenger/.test(ua)) {
      console.log("micromessenger");

      document.addEventListener("WeixinJSBridgeReady", function() {
        _this.wxReady = true;
        if (_this.wxReady && this.loadingCompleted && this.wxReady) {
          setTimeout(() => {
            this.$emit("loadingShow");
          }, 500);
        }
      });
    } else {
      this.wxReady = true;
    }
    this.loadingFirstInit()
  },
  methods: {
    loadingInit() {
      axios.get("assete-manifest.json").then(res => {
        let items = res.data;
        let assets = [];
        for (let i in items) {
          assets.push({
            id: i,
            src: items[i]
          });
        }
        let loadedCount = 0;
        assets.map(async item => {
          const data = await AsyncPreloader.loadItem(item);
          loadedCount++;
          this.percent = Math.round((100 * loadedCount) / assets.length);
          // console.log(`Progress: ${(100 * loadedCount) / assets.length}%`);
          if (this.percent >= 100) {
            // console.log(111)
            // do something...
            // this.$emit('loadingShow')
            this.loadingCompleted = true;
            if (this.aniCompleted && this.loadingCompleted && this.wxReady) {
              this.$emit("loadingShow");
            }
          }
        });
      });
      // return true;
    },
    loadingFirstInit() {
      axios.get("assete-loading.json").then(res => {
        let items = res.data;
        let assets = [];
        for (let i in items) {
          assets.push({
            id: i,
            src: items[i]
          });
        }
        let loadedCount = 0;
        assets.map(async item => {
          const data = await AsyncPreloader.loadItem(item);
          loadedCount++;
          this.percent = Math.round((100 * loadedCount) / assets.length);
          if (this.percent >= 100) {
            this.loadingInit();
            console.log('first');
            this.wordAniPlay = true;
            interval = setInterval(() => {
              let index = this.activeIndex + 1;
              if (index == 11) index = 1;
              this.activeIndex = index;

              if (this.activeIndex == 10) {
                // this.aniCompleted = true
                if (
                  this.aniCompleted &&
                  this.loadingCompleted &&
                  this.wxReady
                ) {
                  this.$nextTick(() => {
                    this.$emit("loadingShow");
                    clearInterval(interval);
                  });
                }
              }
            }, 120);

            setTimeout(() => {
              this.aniCompleted = true;
            }, 5000);
          }
        });
      });
    }
  }
  // watch:{
  //   showLoading(){

  //   }
  // }
};
</script>

<style lang='less'>
.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  // font-family: SourceHanSerifBold;
  .loadingBg {
    width: 750px;
    height: 1624px;
    background: url(../../public/imgs/loading_bg.jpg);
  }
  .loading_tip {
    width: 673px;
    height: 114px;
    margin-top: -490px;
    opacity: 0;
    animation: fadeIn 1s forwards;
    .tip1 {
      width: 0;
      height: 49px;
      position: absolute;
      top: 0;
      left: 150px;
      overflow: hidden;
    }
    .tip1_ani {
      animation: tip_ani_1 2s forwards;
      animation-delay: 1s;
    }
    .tip2 {
      width: 0;
      height: 47px;
      position: absolute;
      top: 71px;
      overflow: hidden;
    }
    .tip2_ani {
      animation: tip_ani_2 2s forwards;
      animation-delay: 3s;
    }
  }

  .paper_container {
    width: 490px;
    height: 600px;
    position: absolute;
    left: -26px;
    right: 0;
    top: 112px;
    bottom: 0;
    margin: auto;
    .papper_ani {
      // width: 710px;
      // height: 840px;
      // background: url(../../public/imgs/loading_papper.png) no-repeat;
      // animation: book_ani 1s steps(11) infinite;
    }
    img {
      opacity: 0;
      position: absolute;
      left: 0;
      &.show {
        opacity: 1;
      }
    }
  }
}

.short {
  .loading_tip {
    margin-top: -420px;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
@keyframes book_ani {
  to {
    background-position: -7810px 0;
  }
}

@keyframes float {
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes papper_ani {
  to {
    background-position: 0px -5136px;
  }
}
@keyframes tip_ani_1 {
  100% {
    opacity: 1;
    width: 373px;
  }
}
@keyframes tip_ani_2 {
  100% {
    opacity: 1;
    width: 673px;
  }
}
@keyframes tip_ani_3 {
  0% {
    height: 0;
  }
  17% {
    height: 225px;
  }
  95% {
    opacity: 1;
    height: 225px;
  }
  100% {
    opacity: 0;
    height: 225px;
  }
}
@keyframes tip_ani_4 {
  0% {
    height: 0;
  }
  50% {
    height: 0;
  }
  67% {
    height: 364px;
  }
  95% {
    opacity: 1;
    height: 364px;
  }
  100% {
    opacity: 0;
    height: 364px;
  }
}
</style>
